import { ref } from 'vue'

export function useFormValidation() {
  const submitAttempted = ref(false)
  const touched = ref<Record<string, boolean>>({})

  /** Mark a field as touched (call on blur) */
  const touch = (field: string) => {
    touched.value[field] = true
  }

  /**
   * Returns the error message if it should currently be visible, or empty string.
   * An error is shown when the field has been touched OR submit was attempted.
   */
  const displayError = (field: string, error: string | null | undefined): string => {
    if (!error) return ''
    if (touched.value[field] || submitAttempted.value) return error
    return ''
  }

  /**
   * Marks submit as attempted and returns true if the form is valid (no errors).
   * Pass an object of current error strings; any truthy value means invalid.
   */
  const attemptSubmit = (errors: Record<string, string | null | undefined>): boolean => {
    submitAttempted.value = true
    return !Object.values(errors).some(Boolean)
  }

  /** Reset all validation state (e.g. when a modal closes or form is cleared) */
  const reset = () => {
    submitAttempted.value = false
    touched.value = {}
  }

  return { submitAttempted, touched, touch, displayError, attemptSubmit, reset }
}
